<template>
  <v-content>
    <tasks-list
      ref="list"
      class="mx-12"
      :title="title"
      :headers="headers"
      :data="data"
      :response="response"
      :loading="loading"
      @details="previewFn"
      @new="newFn"
      @reload="loadTasks()"
      @sort="loadTasks()"
      @hook:mounted="handleMount('list')"
    >
      <template v-slot:select-headers>
        <filter-menu
          ref="filterMenu"
          :filters="filterOptions"
          :headers="headerOptions"
          :menu="filterMenu"
          :show-filter-options="true"
          location="tasks"
          @close="handleCloseFilterMenu"
          @update:filters="handleUpdateFilters"
          @update:headers="handleUpdateHeaders"
          @hook:mounted="handleMount('filterMenu')"
        ></filter-menu>
      </template>
    </tasks-list>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import TasksList from "@/components/lists/TasksList.vue";
import FilterMenu from "@/components/general/FilterMenu.vue";
export default {
  components: {
    TasksList,
    FilterMenu,
  },
  data: () => ({
    mounted: {
      filterMenu: { mounted: false, refs: "filterMenu" },
      list: { mounted: false, refs: "list" },
      root: { mounted: false, refs: null },
    },
    filterMenu: false,
    filterOptions: {
      title: "",
      items: [{ title: "", options: [{ text: "", value: "" }] }],
    },
    options: {},
    headerOptions: [],
    headers: [],
    data: [],
    sort: "name",
    title: "Tasks",
    deleteDialog: false,
    boat: null,
    boatName: null,
    loading: true,
    response: null,
  }),

  created() {
    this.setInitialData();
  },

  mounted() {
    //NOTE: this is here to prevent multiple API calls to the same function. To gether all the parameters from the different components.
    this.handleMount("root");
  },

  methods: {
    handleMount(componentName) {
      if (!this.mounted.hasOwnProperty(componentName)) {
        console.error("TASKS: component name does not exists", componentName);
        return;
      }

      this.mounted[componentName] = {
        ...this.mounted[componentName],
        mounted: true,
      };

      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.loadTasks();
      }
    },
    setInitialData() {
      this.title = this.$t("tasks.tasks.tasks");

      this.filterOptions = {
        title: this.$t("tasks.tasks.filterTasksBy"),
        items: [
          {
            title: this.$t("tasks.tasks.status"),
            feature: null,
            options: [
              {
                text: this.$t("tasks.tasks.all"),
                value: "all",
                active: true,
                default: true,
                server: { name: "status", value: "all" },
              },
              {
                text: this.$t("tasks.tasks.notStarted"),
                value: "not_started",
                active: false,
                default: false,
                server: { name: "status", value: "not_started" },
              },

              {
                text: this.$t("tasks.tasks.inProgress"),
                value: "in_progress",
                active: false,
                default: false,
                server: { name: "status", value: "in_progress" },
              },
              {
                text: this.$t("tasks.tasks.completed"),
                value: "completed",
                active: false,
                default: false,
                server: { name: "status", value: "completed" },
              },
            ],
          },
        ],
      };

      this.headerOptions = [
        {
          text: this.$t("tasks.tasks.taskId"),
          align: "left",
          value: "task_identifier",
          orderingName: "task_identifier",
          sortable: true,
          canHide: true,
        },

        {
          text: this.$t("tasks.tasks.source"),
          align: "left",
          value: "source",
          orderingName: "source",
          sortable: true,
          canHide: true,
        },
        {
          text: this.$t("tasks.tasks.title"),
          align: "left",
          value: "name",
          orderingName: "name",
          sortable: true,
          canHide: true,
        },
        {
          text: this.$t("tasks.tasks.boat"),
          align: "left",
          value: "crm_boat",
          orderingName: "boat_label",
          sortable: true,
          canHide: true,
        },
        {
          text: this.$t("tasks.tasks.assignedTo"),
          align: "left",
          value: "assignee",
          orderingName: "assignee_label",
          sortable: true,
          canHide: true,
        },
        {
          text: this.$t("tasks.tasks.date"),
          align: "left",
          value: "created",
          width: "80px",
          orderingName: "created",
          sortable: true,
          canHide: true,
        },
        {
          text: this.$t("tasks.tasks.dueDate"),
          align: "left",
          value: "due_date",
          width: "80px",
          orderingName: "due_date",
          sortable: true,
          canHide: true,
        },
        {
          text: this.$t("tasks.tasks.priority"),
          align: "center",
          value: "priority",
          width: "30",
          orderingName: "priority",
          sortable: true,
          canHide: true,
        },
        {
          text: this.$t("tasks.tasks.status"),
          align: "center",
          value: "status",
          width: "30",
          orderingName: "status",
          sortable: true,
          canHide: true,
        },
      ];
    },

    handleUpdateFilters() {
      if (this.$refs.list == null) return;
      this.$refs.list.setPage(1);
      this.loadTasks();
    },

    loadTasks() {
      let params = {};

      for (const key in this.mounted) {
        const refs = this.mounted[key].refs;
        if (refs == null) continue;
        params = {
          ...params,
          ...this.$refs[refs].query,
        };
      }

      this.$router.replace({
        name: this.$route.name,
        query: params,
      });

      this.loading = true;
      this.data = [];

      api.getTaskList(params).then((resp) => {
        this.response = resp.data;
        this.data = resp.data.results;
        this.data.forEach((element) => {
          element.priority = Number(element.priority);
        });
        this.loading = false;
      });
    },

    handleCloseFilterMenu(value) {
      this.filterMenu = value;
    },

    handleUpdateHeaders(headers, menu = true) {
      this.headers = this.headerOptions.filter((item) => {
        return headers.includes(item.value);
      });
      this.filterMenu = menu;
    },
    previewFn(task) {
      this.$router.push({
        name: "tasksDetails",
        params: { id: task.uuid },
      });
    },
    newFn(task) {
      this.$router.push({
        name: "tasksNew",
      });
    },
  },
};
</script>
